function xmur3(str) {
  let h = 1779033703 ^ str.length;
  for (let i = 0; i < str.length; i += 1) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return () => {
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    h ^= h >>> 16;
    return h >>> 0;
  };
}

function mulberry32(a) {
  return function random() {
    let t = (a += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function createSeededDeck(seed) {
  const deck = [];
  const colorSets = ['yellow', 'blue', 'green', 'red'];
  for (let colorIndex = 0; colorIndex < colorSets.length; colorIndex += 1) {
    for (let v = 1; v <= 13; v += 1) {
      deck.push({
        id: `${colorSets[colorIndex]}-${v}`,
        value: v,
        color: colorSets[colorIndex]
      });
    }
  }

  const hash = xmur3(seed);
  const random = mulberry32(hash());
  for (let i = deck.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [deck[i], deck[j]] = [deck[j], deck[i]];
  }
  return deck;
}
